import { getCSRFToken } from '@cartwheel/api'
import { useState } from 'react'

export type CsmContactLinkProps = {
  email: string
  name: string
  organizationId: string
  headerText: string
  trackingUrl: string
}

export default function CsmContactLink({
  email,
  name,
  organizationId,
  headerText,
  trackingUrl,
}: CsmContactLinkProps) {
  const [isTracking, setIsTracking] = useState(false)

  const handleClick = async () => {
    if (isTracking) return

    setIsTracking(true)

    try {
      await fetch(trackingUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCSRFToken(),
        },
        body: JSON.stringify({ organization_id: organizationId }),
      })
    } catch (error) {
      // Silently ignore tracking failures - don't block user action
      console.error('Tracking failed:', error)
    } finally {
      setIsTracking(false)
      // Open mailto link after tracking
      window.location.href = `mailto:${email}`
    }
  }

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <p className="mb-2 text-charcoal-50">{headerText}</p>
      <button
        type="button"
        onClick={handleClick}
        disabled={isTracking}
        className="inline-flex items-center gap-2 cursor-pointer disabled:opacity-50"
      >
        <span className="font-medium underline text-indigo">{name}</span>
        <i className="fa-solid fa-envelope text-indigo" aria-hidden="true" />
      </button>
    </div>
  )
}
